module.exports = __webpack_public_path__ + "img/manjianquan_bg.93fd7346.png";